export default __webpack_public_path__ + "static/media/day-sound.802f6704.mp3";